import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useWishlist } from "../context/WishlistContext";
import { useTranslation } from "react-i18next";
import ProductCard from "../components/ProductCard";

const loggedIn = () =>
  localStorage.getItem("authToken") && localStorage.getItem("isGuest") !== "true";

const Wishlist = () => {
  const { enabled, items, loading, fetchItems } = useWishlist();
  const { t } = useTranslation();

  useEffect(() => { if (enabled && loggedIn()) fetchItems(); }, [enabled, fetchItems]);

  const wrap = (inner) => (
    <Container className="my-5" style={{ minHeight: "50vh" }}>
      <ToastContainer position="bottom-right" autoClose={3000} />
      <h2 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, marginBottom: 24 }}>
        {t("wishlist.title")}
      </h2>
      {inner}
    </Container>
  );

  if (!enabled) {
    return wrap(<p className="text-muted">{t("wishlist.unavailable")}</p>);
  }
  if (!loggedIn()) {
    return wrap(
      <div className="text-center py-5">
        <p className="text-muted mb-3">{t("wishlist.loginPrompt")}</p>
        <Link to="/login" className="btn btn-warning">{t("nav.login")}</Link>
      </div>
    );
  }
  if (loading) return wrap(<p className="text-muted">{t("wishlist.loading")}</p>);
  if (!items.length) {
    return wrap(
      <div className="text-center py-5">
        <div style={{ fontSize: "3rem" }}>🤍</div>
        <p className="text-muted mb-3">{t("wishlist.empty")}</p>
        <Link to="/shop" className="btn btn-warning">{t("cart.browseProducts")}</Link>
      </div>
    );
  }

  return wrap(
    <Row className="g-3">
      {items.map((p) => (
        <Col key={p._id} xs={6} sm={6} md={4} lg={3} xl={2} className="d-flex justify-content-center">
          <ProductCard product={p} productImageUrl={p.imageUrl} />
        </Col>
      ))}
    </Row>
  );
};

export default Wishlist;
